import React from 'react';
import styled from 'styled-components';
import { FaTooth, FaPhone, FaCalendarAlt, FaClock, FaMapMarkerAlt, FaCheck, FaStar, FaUserMd } from 'react-icons/fa';
import DemoViewer from '../../components/DemoViewer';
import SEO from '../../components/SEO';

// Estilos para la demo de clínica dental
const DentistDemo = styled.div`
  font-family: 'Poppins', sans-serif;
  color: #333;
`;

const HeroSection = styled.div`
  background-image: url('/servicios/tipo-cliente/dentistas-hero.webp');
  background-size: cover;
  background-position: center;
  height: 600px;
  display: flex;
  align-items: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }
`;

const HeroContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const HeroContent = styled.div`
  flex: 1;
  min-width: 300px;
  color: white;
  margin-right: 2rem;
`;

const HeroTitle = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  color: white;
`;

const HeroSubtitle = styled.p`
  font-size: 1.25rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  max-width: 500px;
`;

const AppointmentForm = styled.div`
  flex: 0 0 350px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 2rem;
`;

const FormTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: #1a73e8;
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const FormLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #555;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #1a73e8;
  }
`;

const FormSelect = styled.select`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #1a73e8;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  background-color: #1a73e8;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #1557b0;
  }
`;

const Section = styled.section`
  padding: 5rem 2rem;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 1rem;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 3rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
`;

const ServiceCard = styled.div`
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
`;

const ServiceImage = styled.div`
  height: 200px;
  background-color: #eee;
  background-size: cover;
  background-position: center;
`;

const ServiceContent = styled.div`
  padding: 1.5rem;
`;

const ServiceTitle = styled.h3`
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #1a73e8;
`;

const ServiceDescription = styled.p`
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const ServiceButton = styled.button`
  background-color: transparent;
  color: #1a73e8;
  border: 1px solid #1a73e8;
  padding: 0.75rem 1.5rem;
  font-size: 0.9rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #1a73e8;
    color: white;
  }
`;

const WhyChooseUsSection = styled(Section)`
  background-color: #f9f9f9;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
`;

const FeatureCard = styled.div`
  text-align: center;
  padding: 2rem;
`;

const FeatureIcon = styled.div`
  font-size: 2.5rem;
  color: #1a73e8;
  margin-bottom: 1.5rem;
`;

const FeatureTitle = styled.h3`
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #333;
`;

const FeatureDescription = styled.p`
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
`;

const TeamSection = styled(Section)``;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
`;

const TeamMember = styled.div`
  text-align: center;
`;

const MemberImage = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #eee;
  margin: 0 auto 1.5rem;
  background-size: cover;
  background-position: center;
`;

const MemberName = styled.h3`
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  color: #1a73e8;
`;

const MemberRole = styled.p`
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 1rem;
`;

const MemberBio = styled.p`
  color: #666;
  font-size: 0.9rem;
  line-height: 1.6;
`;

const TestimonialsSection = styled(Section)`
  background-color: #f9f9f9;
`;

const TestimonialsContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const TestimonialCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
`;

const TestimonialText = styled.p`
  font-style: italic;
  color: #555;
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
`;

const AuthorImage = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #eee;
  margin-right: 1rem;
  background-size: cover;
  background-position: center;
`;

const AuthorInfo = styled.div``;

const AuthorName = styled.h4`
  margin: 0 0 0.25rem;
  font-size: 1.1rem;
`;

const AuthorRating = styled.div`
  color: #f1c40f;
  font-size: 0.9rem;
`;

const ContactSection = styled(Section)`
  background-color: #1a73e8;
  color: white;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const ContactCard = styled.div`
  padding: 2rem;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

const ContactIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
`;

const ContactTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
`;

const ContactText = styled.p`
  line-height: 1.6;
  font-size: 1rem;
`;

const Footer = styled.footer`
  background-color: #0d47a1;
  color: white;
  padding: 2rem;
  text-align: center;
  
  p {
    color: rgba(255, 255, 255, 0.7);
  }
`;

const DentistasDemoPage: React.FC = () => {
  return (
    <>
      <SEO 
        title="Demo de Sitio Web para Clínicas Dentales | Web a Bajo Coste"
        description="Visualiza cómo quedaría tu clínica dental online con este ejemplo interactivo. Diseño optimizado para atraer pacientes y gestionar citas."
        keywords="demo web dental, diseño web dentistas, ejemplo web clínica dental"
        canonical="https://webabajocoste.es/plantillas/dentista"
      >
        <meta name="robots" content="noindex, nofollow" />
      </SEO>
      
      <DemoViewer
        title="Demo Web para Clínicas Dentales"
        subtitle="Visualiza cómo podría ser tu nueva web dental, diseñada para generar confianza y conseguir nuevos pacientes"
        domainName="https://clinicadentalsonrisas.es"
        serviceLink="/servicios/diseno-web-dentistas"
        serviceName="Dentistas"
      >
        <DentistDemo>
          <HeroSection>
            <HeroContainer>
              <HeroContent>
                <HeroTitle>Sonrisas sanas para toda la familia</HeroTitle>
                <HeroSubtitle>Ofrecemos atención dental de alta calidad con la última tecnología y un equipo especializado.</HeroSubtitle>
              </HeroContent>
              
              <AppointmentForm>
                <FormTitle>Solicita tu cita</FormTitle>
                
                <FormGroup>
                  <FormLabel>Nombre completo</FormLabel>
                  <FormInput type="text" placeholder="Introduce tu nombre" />
                </FormGroup>
                
                <FormGroup>
                  <FormLabel>Teléfono</FormLabel>
                  <FormInput type="tel" placeholder="Introduce tu teléfono" />
                </FormGroup>
                
                <FormGroup>
                  <FormLabel>Tipo de consulta</FormLabel>
                  <FormSelect>
                    <option value="">Selecciona una consulta</option>
                    <option value="revision">Revisión general</option>
                    <option value="limpieza">Limpieza dental</option>
                    <option value="urgencia">Urgencia dental</option>
                    <option value="ortodoncia">Ortodoncia</option>
                    <option value="estetica">Estética dental</option>
                  </FormSelect>
                </FormGroup>
                
                <FormGroup>
                  <FormLabel>Fecha preferida</FormLabel>
                  <FormInput type="date" />
                </FormGroup>
                
                <SubmitButton>Solicitar Cita</SubmitButton>
              </AppointmentForm>
            </HeroContainer>
          </HeroSection>
          
          <Section>
            <Container>
              <SectionTitle>Nuestros Servicios</SectionTitle>
              <SectionSubtitle>Ofrecemos una amplia gama de tratamientos dentales para cubrir todas tus necesidades</SectionSubtitle>
              
              <ServicesGrid>
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dental-limpieza.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>Limpieza y Prevención</ServiceTitle>
                    <ServiceDescription>
                      Mantén tu salud bucal con nuestros tratamientos preventivos que incluyen limpiezas profundas, radiografías y revisiones completas.
                    </ServiceDescription>
                    <ServiceButton>Ver más</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dental-ortodoncia.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>Ortodoncia</ServiceTitle>
                    <ServiceDescription>
                      Corrige la posición de tus dientes con nuestros tratamientos de ortodoncia tradicional o invisible para todas las edades.
                    </ServiceDescription>
                    <ServiceButton>Ver más</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dental-blanqueamiento.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>Estética Dental</ServiceTitle>
                    <ServiceDescription>
                      Consigue la sonrisa que siempre has soñado con nuestros tratamientos de blanqueamiento, carillas y otros procedimientos estéticos.
                    </ServiceDescription>
                    <ServiceButton>Ver más</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dental-implantes.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>Implantes Dentales</ServiceTitle>
                    <ServiceDescription>
                      Recupera tu sonrisa con implantes dentales de última generación que te devolverán la funcionalidad y estética natural.
                    </ServiceDescription>
                    <ServiceButton>Ver más</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dental-endodoncia.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>Endodoncia</ServiceTitle>
                    <ServiceDescription>
                      Tratamientos de conducto sin dolor con la última tecnología para salvar tus dientes y eliminar las infecciones.
                    </ServiceDescription>
                    <ServiceButton>Ver más</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dental-odontopediatria.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>Odontopediatría</ServiceTitle>
                    <ServiceDescription>
                      Atención especializada para los más pequeños en un ambiente amigable que les ayudará a mantener una buena salud bucal.
                    </ServiceDescription>
                    <ServiceButton>Ver más</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
              </ServicesGrid>
            </Container>
          </Section>
          
          <WhyChooseUsSection>
            <Container>
              <SectionTitle>¿Por qué elegirnos?</SectionTitle>
              <SectionSubtitle>Nuestra misión es brindar la mejor atención dental basada en la confianza, la calidad y tu comodidad</SectionSubtitle>
              
              <FeatureGrid>
                <FeatureCard>
                  <FeatureIcon>
                    <FaUserMd />
                  </FeatureIcon>
                  <FeatureTitle>Profesionales Cualificados</FeatureTitle>
                  <FeatureDescription>
                    Nuestro equipo está formado por dentistas con amplia experiencia y formación continua.
                  </FeatureDescription>
                </FeatureCard>
                
                <FeatureCard>
                  <FeatureIcon>
                    <FaTooth />
                  </FeatureIcon>
                  <FeatureTitle>Tecnología Avanzada</FeatureTitle>
                  <FeatureDescription>
                    Contamos con equipos de última generación para ofrecerte diagnósticos precisos y tratamientos efectivos.
                  </FeatureDescription>
                </FeatureCard>
                
                <FeatureCard>
                  <FeatureIcon>
                    <FaCheck />
                  </FeatureIcon>
                  <FeatureTitle>Garantía en Tratamientos</FeatureTitle>
                  <FeatureDescription>
                    Ofrecemos garantía en todos nuestros tratamientos para que tengas total tranquilidad.
                  </FeatureDescription>
                </FeatureCard>
                
                <FeatureCard>
                  <FeatureIcon>
                    <FaClock />
                  </FeatureIcon>
                  <FeatureTitle>Horario Flexible</FeatureTitle>
                  <FeatureDescription>
                    Adaptamos nuestros horarios a tus necesidades para que puedas visitarnos cuando mejor te convenga.
                  </FeatureDescription>
                </FeatureCard>
              </FeatureGrid>
            </Container>
          </WhyChooseUsSection>
          
          <TeamSection>
            <Container>
              <SectionTitle>Nuestro Equipo</SectionTitle>
              <SectionSubtitle>Conoce a los profesionales que cuidarán de tu salud bucal con dedicación y experiencia</SectionSubtitle>
              
              <TeamGrid>
                <TeamMember>
                  <MemberImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dentista1.webp")' }} />
                  <MemberName>Dra. Lucía Martínez</MemberName>
                  <MemberRole>Directora Médica - Ortodoncista</MemberRole>
                  <MemberBio>
                    Especialista en ortodoncia con más de 15 años de experiencia. Formada en las técnicas más avanzadas.
                  </MemberBio>
                </TeamMember>
                
                <TeamMember>
                  <MemberImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dentista2.webp")' }} />
                  <MemberName>Dr. Javier Rodríguez</MemberName>
                  <MemberRole>Implantólogo</MemberRole>
                  <MemberBio>
                    Experto en implantes dentales y cirugía oral. Su precisión y dedicación son garantía de éxito.
                  </MemberBio>
                </TeamMember>
                
                <TeamMember>
                  <MemberImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dentista3.webp")' }} />
                  <MemberName>Dra. Elena López</MemberName>
                  <MemberRole>Odontopediatra</MemberRole>
                  <MemberBio>
                    Especializada en el tratamiento dental infantil, con un enfoque amigable que los niños adoran.
                  </MemberBio>
                </TeamMember>
                
                <TeamMember>
                  <MemberImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/dentista4.webp")' }} />
                  <MemberName>Dr. Carlos Sánchez</MemberName>
                  <MemberRole>Endodoncista</MemberRole>
                  <MemberBio>
                    Especialista en tratamientos de conducto, con un enfoque en tratamientos sin dolor.
                  </MemberBio>
                </TeamMember>
              </TeamGrid>
            </Container>
          </TeamSection>
          
          <TestimonialsSection>
            <Container>
              <SectionTitle>Opiniones de nuestros pacientes</SectionTitle>
              <SectionSubtitle>Descubre por qué nuestros pacientes confían en nosotros para sus tratamientos dentales</SectionSubtitle>
              
              <TestimonialsContainer>
                <TestimonialCard>
                  <TestimonialText>
                    "Increíble experiencia en esta clínica. El Dr. Rodríguez me hizo un tratamiento de implantes y el resultado ha sido perfecto. Además, todo el personal es muy amable y profesional."
                  </TestimonialText>
                  <TestimonialAuthor>
                    <AuthorImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/cliente1.webp")' }} />
                    <AuthorInfo>
                      <AuthorName>Laura Gómez</AuthorName>
                      <AuthorRating>
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                      </AuthorRating>
                    </AuthorInfo>
                  </TestimonialAuthor>
                </TestimonialCard>
                
                <TestimonialCard>
                  <TestimonialText>
                    "Llevamos a nuestros hijos desde hace años y siempre han tenido una experiencia positiva. La Dra. Elena tiene un don especial con los niños y les ha quitado el miedo al dentista."
                  </TestimonialText>
                  <TestimonialAuthor>
                    <AuthorImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/cliente2.webp")' }} />
                    <AuthorInfo>
                      <AuthorName>Miguel Fernández</AuthorName>
                      <AuthorRating>
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                      </AuthorRating>
                    </AuthorInfo>
                  </TestimonialAuthor>
                </TestimonialCard>
              </TestimonialsContainer>
            </Container>
          </TestimonialsSection>
          
          <ContactSection>
            <Container>
              <SectionTitle>Contacto</SectionTitle>
              <SectionSubtitle>Estamos aquí para resolver todas tus dudas y atender tus necesidades dentales</SectionSubtitle>
              
              <ContactGrid>
                <ContactCard>
                  <ContactIcon>
                    <FaMapMarkerAlt />
                  </ContactIcon>
                  <ContactTitle>Ubicación</ContactTitle>
                  <ContactText>
                    Calle Serrano, 45<br />
                    28001 Madrid
                  </ContactText>
                </ContactCard>
                
                <ContactCard>
                  <ContactIcon>
                    <FaPhone />
                  </ContactIcon>
                  <ContactTitle>Teléfono</ContactTitle>
                  <ContactText>
                    912 345 678<br />
                    Horario de atención: 9:00 - 20:00
                  </ContactText>
                </ContactCard>
                
                <ContactCard>
                  <ContactIcon>
                    <FaCalendarAlt />
                  </ContactIcon>
                  <ContactTitle>Citas</ContactTitle>
                  <ContactText>
                    Reserva tu cita online<br />
                    o llámanos por teléfono
                  </ContactText>
                </ContactCard>
              </ContactGrid>
            </Container>
          </ContactSection>
          
          <Footer>
            <p>© 2025 Clínica Dental Sonrisas | Todos los derechos reservados</p>
          </Footer>
        </DentistDemo>
      </DemoViewer>
    </>
  );
};

export default DentistasDemoPage; 